import { useQuery } from "@apollo/client/react";
import { USER_BLACKOUT_DATES_QUERY } from "../../constants/graphql/queries";

export default function useBlackoutDates() {
  const { data: { user } = {}, ...rest } = useQuery(USER_BLACKOUT_DATES_QUERY);
  const { blackoutDates = {} } = user?.company || {};
  return { blackoutDates, ...rest };
}
